import React from 'react';
import { Box, Typography, Button, Paper, Container, useTheme } from '@mui/material';
import { Block as BlockIcon, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * Página de acesso não autorizado
 * Exibida quando o usuário tenta acessar uma rota sem permissão
 */
const UnauthorizedPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 5, 
          borderRadius: 4,
          textAlign: 'center',
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            mb: 3 
          }}
        >
          <Box 
            sx={{ 
              width: 80, 
              height: 80, 
              bgcolor: theme.palette.error.light, 
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2
            }}
          >
            <BlockIcon sx={{ fontSize: 40, color: 'white' }} />
          </Box>
          
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Acesso Negado
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '80%' }}>
            Você não possui permissão para acessar esta página. 
            Esta área é restrita para usuários com perfil diferente do seu.
          </Typography>
          
          <Button 
            variant="contained" 
            startIcon={<HomeIcon />}
            onClick={() => navigate('/home')}
            sx={{ 
              px: 4, 
              py: 1.2, 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Voltar para a página inicial
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnauthorizedPage; 